// src/components/Footer/Footer.js
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import './Footer.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import sx from '../../images/favicon/favicon-32x32.png'; // Old favicon import
import csStamp from '../../images/cs_white.png'; // Your new copyright stamp image
import { t } from "@lingui/core/macro"; // Needed for copyright year and company name

const Footer = () =>
{
    // Get current year dynamically (good practice for copyright)
    const currentYear = new Date().getFullYear();

    return (
        <div className='footer'>
            <div className="footer_container">
                {/* LinkedIn Link (Icon and text) */}
                <div className="social-link"> {/* New wrapper for social link */}
                    <a href="https://www.linkedin.com/company/cosmic-shores-spaceports/" target="_blank" rel="noopener noreferrer"> 
                        <FontAwesomeIcon icon={faLinkedinIn} />
                    </a>
                </div>

                {/* Optional: Add the main logo here if you want it prominent in the footer */}
                {/* <div className="footer-logo">
                    <img src={yourMainLogo} alt="The Cosmic Shores Logo" />
                </div> */}

                {/* Copyright and Company Stamp */}
                <div className="copyright-info"> {/* New wrapper for copyright text and stamp */}
                     <p className='legal-statement open_sans'>
                    {t`The Cosmic Shores es una corporación registrada en Florida, USA.`}
                        </p>
                    {/* Placeholder for the real image. Assuming CS-stamp.png contains the text like "The Cosmic Shores" + symbol */}
                    <p className='open_sans'>
                        &nbsp; &copy; 2024–{currentYear} {t`The Cosmic Shores`}, {t`Todos los Derechos Reservados.`}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Footer;
